import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { createCheckout } from '../../services/api';

const StressManagementTab = ({ hasStressAccess, selectedProgramId, userEmail }) => {
  const [stressLevel, setStressLevel] = useState(5);

  // Cohérence cardiaque (4-6)
  const [breathingActive, setBreathingActive] = useState(false);
  const [breathingPhase, setBreathingPhase] = useState('');
  const [breathingCount, setBreathingCount] = useState(0);
  const [breathingCycle, setBreathingCycle] = useState(0);
  const breathingRef = useRef(null);

  // 4-4-6
  const [breathingActive446, setBreathingActive446] = useState(false);
  const [breathingPhase446, setBreathingPhase446] = useState('');
  const [breathingCount446, setBreathingCount446] = useState(0);
  const [breathingCycle446, setBreathingCycle446] = useState(0);
  const breathing446Ref = useRef(null);

  // Carrée 4-4-4-4
  const [breathingActiveSquare, setBreathingActiveSquare] = useState(false);
  const [breathingPhaseSquare, setBreathingPhaseSquare] = useState('');
  const [breathingCountSquare, setBreathingCountSquare] = useState(0);
  const [breathingCycleSquare, setBreathingCycleSquare] = useState(0);
  const breathingSquareRef = useRef(null);

  // Soupir physiologique
  const [soupirVideoPlaying, setSoupirVideoPlaying] = useState(false);
  const soupirVideoRef = useRef(null);

  // Alternée
  const [breathingActiveAlternee, setBreathingActiveAlternee] = useState(false);
  const [breathingPhaseAlternee, setBreathingPhaseAlternee] = useState('');
  const [breathingCountAlternee, setBreathingCountAlternee] = useState(0);
  const [breathingCycleAlternee, setBreathingCycleAlternee] = useState(0);
  const breathingAlterneeRef = useRef(null);

  const speak = (text) => new Promise((resolve) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'fr-FR';
    utterance.rate = 0.85;
    utterance.pitch = 1.0;
    utterance.onend = resolve;
    utterance.onerror = resolve;
    window.speechSynthesis.speak(utterance);
  });

  const wait = (ms) => new Promise(r => setTimeout(r, ms));

  // Refs sync
  useEffect(() => { breathingRef.current = breathingActive; }, [breathingActive]);
  useEffect(() => { breathing446Ref.current = breathingActive446; }, [breathingActive446]);
  useEffect(() => { breathingSquareRef.current = breathingActiveSquare; }, [breathingActiveSquare]);
  useEffect(() => { breathingAlterneeRef.current = breathingActiveAlternee; }, [breathingActiveAlternee]);

  const startBreathingExercise = async () => {
    setBreathingActive(true);
    setBreathingCycle(0);
    window.speechSynthesis.cancel();
    await speak('Installez-vous confortablement.');
    await wait(1500);
    for (let cycle = 1; cycle <= 10; cycle++) {
      if (breathingRef.current === false) break;
      setBreathingCycle(cycle);
      if (cycle === 10) { await speak('Une dernière fois.'); await wait(500); }
      else if (cycle > 1 && cycle % 3 === 1) { await speak('On recommence.'); await wait(500); }
      setBreathingPhase('inspire');
      await speak('Inspirez.');
      for (let i = 1; i <= 4; i++) { if (breathingRef.current === false) break; setBreathingCount(i); await wait(1000); }
      if (breathingRef.current === false) break;
      setBreathingPhase('expire');
      await speak('Expirez.');
      for (let i = 1; i <= 6; i++) { if (breathingRef.current === false) break; setBreathingCount(i); await wait(1000); }
    }
    if (breathingRef.current !== false) {
      setBreathingPhase('');
      setBreathingCount(0);
      await speak('Bravo ! L\'exercice est terminé. Vous pouvez reprendre vos activités en douceur.');
    }
    setBreathingActive(false); setBreathingPhase(''); setBreathingCount(0); setBreathingCycle(0);
  };

  const startBreathingExercise446 = async () => {
    setBreathingActive446(true);
    setBreathingCycle446(0);
    window.speechSynthesis.cancel();
    await speak('Installez-vous confortablement. Respiration quatre, quatre, six.');
    await wait(1500);
    for (let cycle = 1; cycle <= 8; cycle++) {
      if (breathing446Ref.current === false) break;
      setBreathingCycle446(cycle);
      if (cycle === 8) { await speak('Une dernière fois.'); await wait(500); }
      else if (cycle > 1 && cycle % 3 === 1) { await speak('On recommence.'); await wait(500); }
      setBreathingPhase446('inspire');
      await speak('Inspirez par le nez.');
      for (let i = 1; i <= 4; i++) { if (breathing446Ref.current === false) break; setBreathingCount446(i); await wait(1000); }
      if (breathing446Ref.current === false) break;
      setBreathingPhase446('bloque');
      await speak('Bloquez.');
      for (let i = 1; i <= 4; i++) { if (breathing446Ref.current === false) break; setBreathingCount446(i); await wait(1000); }
      if (breathing446Ref.current === false) break;
      setBreathingPhase446('expire');
      await speak('Expirez par la bouche.');
      for (let i = 1; i <= 6; i++) { if (breathing446Ref.current === false) break; setBreathingCount446(i); await wait(1000); }
    }
    if (breathing446Ref.current !== false) { setBreathingPhase446(''); setBreathingCount446(0); await speak('Bravo ! L\'exercice est terminé.'); }
    setBreathingActive446(false); setBreathingPhase446(''); setBreathingCount446(0); setBreathingCycle446(0);
  };

  const startBreathingExerciseSquare = async () => {
    setBreathingActiveSquare(true);
    setBreathingCycleSquare(0);
    window.speechSynthesis.cancel();
    await speak('Installez-vous confortablement. Respiration carrée, quatre temps égaux.');
    await wait(1500);
    for (let cycle = 1; cycle <= 8; cycle++) {
      if (breathingSquareRef.current === false) break;
      setBreathingCycleSquare(cycle);
      if (cycle === 8) { await speak('Une dernière fois.'); await wait(500); }
      else if (cycle > 1 && cycle % 3 === 1) { await speak('On recommence.'); await wait(500); }
      setBreathingPhaseSquare('inspire');
      await speak('Inspirez.');
      for (let i = 1; i <= 4; i++) { if (breathingSquareRef.current === false) break; setBreathingCountSquare(i); await wait(1000); }
      if (breathingSquareRef.current === false) break;
      setBreathingPhaseSquare('bloque1');
      await speak('Retenez.');
      for (let i = 1; i <= 4; i++) { if (breathingSquareRef.current === false) break; setBreathingCountSquare(i); await wait(1000); }
      if (breathingSquareRef.current === false) break;
      setBreathingPhaseSquare('expire');
      await speak('Expirez.');
      for (let i = 1; i <= 4; i++) { if (breathingSquareRef.current === false) break; setBreathingCountSquare(i); await wait(1000); }
      if (breathingSquareRef.current === false) break;
      setBreathingPhaseSquare('bloque2');
      await speak('Retenez.');
      for (let i = 1; i <= 4; i++) { if (breathingSquareRef.current === false) break; setBreathingCountSquare(i); await wait(1000); }
    }
    if (breathingSquareRef.current !== false) { setBreathingPhaseSquare(''); setBreathingCountSquare(0); await speak('Bravo ! L\'exercice est terminé.'); }
    setBreathingActiveSquare(false); setBreathingPhaseSquare(''); setBreathingCountSquare(0); setBreathingCycleSquare(0);
  };

  const startBreathingExerciseAlternee = async () => {
    setBreathingActiveAlternee(true);
    setBreathingCycleAlternee(0);
    window.speechSynthesis.cancel();
    await speak('Installez-vous confortablement. Respiration alternée.');
    await wait(1500);
    for (let cycle = 1; cycle <= 6; cycle++) {
      if (breathingAlterneeRef.current === false) break;
      setBreathingCycleAlternee(cycle);
      if (cycle === 6) { await speak('Dernier cycle.'); await wait(500); }
      setBreathingPhaseAlternee('inspire-gauche');
      await speak('Bouchez la narine droite. Inspirez par la gauche.');
      for (let i = 1; i <= 4; i++) { if (breathingAlterneeRef.current === false) break; setBreathingCountAlternee(i); await wait(1000); }
      if (breathingAlterneeRef.current === false) break;
      setBreathingPhaseAlternee('expire-droite');
      await speak('Bouchez la gauche. Expirez par la droite.');
      for (let i = 1; i <= 4; i++) { if (breathingAlterneeRef.current === false) break; setBreathingCountAlternee(i); await wait(1000); }
      if (breathingAlterneeRef.current === false) break;
      setBreathingPhaseAlternee('inspire-droite');
      await speak('Inspirez par la droite.');
      for (let i = 1; i <= 4; i++) { if (breathingAlterneeRef.current === false) break; setBreathingCountAlternee(i); await wait(1000); }
      if (breathingAlterneeRef.current === false) break;
      setBreathingPhaseAlternee('expire-gauche');
      await speak('Bouchez la droite. Expirez par la gauche.');
      for (let i = 1; i <= 4; i++) { if (breathingAlterneeRef.current === false) break; setBreathingCountAlternee(i); await wait(1000); }
    }
    if (breathingAlterneeRef.current !== false) { setBreathingPhaseAlternee(''); setBreathingCountAlternee(0); await speak('Bravo ! L\'exercice est terminé. Votre mental est apaisé.'); }
    setBreathingActiveAlternee(false); setBreathingPhaseAlternee(''); setBreathingCountAlternee(0); setBreathingCycleAlternee(0);
  };

  return (
    <div>
            <h2 className="heading-1" style={{ marginBottom: '1rem' }}>
              Gestion du stress et bien-être
            </h2>
            <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
              Apprenez à gérer votre stress pour aborder sereinement votre parcours VAE et l'oral devant le jury.
            </p>

            {!hasStressAccess ? (
              <div data-testid="stress-paywall" style={{ textAlign: 'center', padding: '3rem 1.5rem', background: 'linear-gradient(135deg, #FDF2F8, #FCE7F3)', border: '2px solid #F9A8D4', borderRadius: '1rem' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>&#129504;</div>
                <h3 className="heading-2" style={{ marginBottom: '0.75rem', color: '#9D174D' }}>
                  Option Gestion du stress
                </h3>
                <p className="body-large" style={{ marginBottom: '0.5rem', color: '#BE185D' }}>
                  5 exercices de respiration guidés + techniques anti-stress
                </p>
                <p className="body-small" style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto 1.5rem auto' }}>
                  Cohérence cardiaque, respiration 4-4-6, respiration carrée, soupir physiologique, respiration alternée — avec vidéo guidée et rappels pédagogiques pour aborder sereinement votre oral.
                </p>
                <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
                  <span style={{ background: '#FFF1F2', color: '#9D174D', padding: '0.35rem 1rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>5 exercices guidés</span>
                  <span style={{ background: '#FFF1F2', color: '#9D174D', padding: '0.35rem 1rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>Vidéo de relaxation</span>
                  <span style={{ background: '#FFF1F2', color: '#9D174D', padding: '0.35rem 1rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>Techniques anti-stress</span>
                </div>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#9D174D', marginBottom: '1.25rem' }}>
                  49 €
                </div>
                <button
                  className="btn-primary"
                  data-testid="buy-stress-option"
                  onClick={async () => {
                    try {
                      const data = await createCheckout({
                        programId: selectedProgramId || 'deap',
                        formula: 'kit',
                        kitId: 'gestion-stress',
                        kitTitle: 'Gestion du stress',
                        price: 49,
                        origin: window.location.origin,
                        email: user.email,
                        nom: user.name?.split(' ').slice(1).join(' ') || '',
                        prenom: user.name?.split(' ')[0] || '',
                        telephone: user.phone || user.telephone || ''
                      });
                      if (data.url) window.location.href = data.url;
                    } catch (e) {
                      alert("Erreur lors de la création du paiement. Veuillez réessayer.");
                    }
                  }}
                  style={{ fontSize: '1rem', padding: '0.85rem 2.5rem' }}
                >
                  Débloquer l'accès — 49 €
                </button>
              </div>
            ) : (
            <>

            {/* Rappel pédagogique */}
            <div data-testid="pedagogical-reminder" style={{ marginBottom: '2rem', background: 'linear-gradient(135deg, #F0FDF4, #DCFCE7)', border: '2px solid #86EFAC', borderRadius: '1rem', padding: '1.5rem' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem', color: '#166534', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ fontSize: '1.4rem' }}>&#129504;</span> Petit rappel pédagogique
              </h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: '0.75rem' }}>
                <li className="body-small" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', lineHeight: 1.6 }}>
                  <span style={{ background: '#BBF7D0', color: '#166534', borderRadius: '50%', minWidth: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem' }}>1</span>
                  <span>Le stress active le <strong>système sympathique</strong> (fuite/combat).</span>
                </li>
                <li className="body-small" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', lineHeight: 1.6 }}>
                  <span style={{ background: '#BBF7D0', color: '#166534', borderRadius: '50%', minWidth: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem' }}>2</span>
                  <span>La respiration lente active le <strong>système parasympathique</strong> (repos/récupération).</span>
                </li>
                <li className="body-small" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', lineHeight: 1.6 }}>
                  <span style={{ background: '#BBF7D0', color: '#166534', borderRadius: '50%', minWidth: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem' }}>3</span>
                  <span>L'<strong>expiration longue</strong> est la clé du retour au calme.</span>
                </li>
                <li className="body-small" style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', lineHeight: 1.6 }}>
                  <span style={{ background: '#BBF7D0', color: '#166534', borderRadius: '50%', minWidth: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem' }}>4</span>
                  <span><strong>1 minute</strong> de respiration contrôlée peut suffire à diminuer le rythme cardiaque.</span>
                </li>
              </ul>
            </div>

            {/* Vidéo de détente */}
            <div className="card" data-testid="stress-video-section" style={{ marginBottom: '2rem', padding: '1.5rem', border: '2px solid #0D9488', borderRadius: '1rem' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem', color: '#0D9488' }}>
                Moment de détente pour le jour de ton oral
              </h3>
              <p className="body-small" style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}>
                Prenez quelques minutes pour vous détendre avant votre passage devant le jury.
              </p>
              <div style={{ borderRadius: '0.75rem', overflow: 'hidden', background: '#000' }}>
                <video
                  data-testid="stress-video-player"
                  controls
                  style={{ width: '100%', maxHeight: '500px', display: 'block' }}
                  preload="metadata"
                >
                  <source src="https://customer-assets.emergentagent.com/job_7ea634f4-6c60-43bd-ad87-41da18485b19/artifacts/uxw00xw2_Moment%20de%20d%C3%A9tente%20pour%20le%20jour%20de%20ton%20oral%20%23pourtoi%20%23VAE%20%23oral%20%23jury%20%281%29.mp4" type="video/mp4" />
                  Votre navigateur ne supporte pas la lecture de vidéos.
                </video>
              </div>
            </div>

            {/* Stress Level Assessment */}
            <div className="card accent-purple" style={{ marginBottom: '2rem', padding: '1.5rem' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
                Évaluez votre niveau de stress
              </h3>
              <p className="body-small" style={{ marginBottom: '1rem' }}>
                Sur une échelle de 1 à 10, comment évaluez-vous votre niveau de stress actuel ?
              </p>
              <input
                type="range"
                min="1"
                max="10"
                value={stressLevel}
                onChange={(e) => setStressLevel(Number(e.target.value))}
                style={{
                  width: '100%',
                  marginBottom: '1rem',
                  accentColor: 'var(--text-primary)'
                }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                <span className="caption">Faible (1)</span>
                <span className="heading-2">{stressLevel}/10</span>
                <span className="caption">Élevé (10)</span>
              </div>
              <div className="card" style={{ padding: '1rem', background: stressLevel > 7 ? '#FCC9C7' : stressLevel > 4 ? '#FEEFDC' : '#b8d1ba' }}>
                <p className="body-small">
                  {stressLevel > 7 && "Votre niveau de stress est élevé. Nous vous recommandons de pratiquer quotidiennement les exercices ci-dessous et de contacter votre accompagnateur."}
                  {stressLevel > 4 && stressLevel <= 7 && "Votre niveau de stress est modéré. Les techniques de relaxation peuvent vous aider à mieux gérer cette période."}
                  {stressLevel <= 4 && "Votre niveau de stress semble maîtrisé. Continuez à pratiquer les exercices de relaxation pour maintenir cet équilibre."}
                </p>
              </div>
            </div>

            {/* Dossier Technique de Respiration */}
            <div data-testid="breathing-technique-section" style={{ marginBottom: '2rem', border: '2px solid #5B8FB9', borderRadius: '1rem', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #5B8FB9 0%, #7AB8D9 100%)', padding: '1.25rem 1.5rem', color: 'white' }}>
                <h3 style={{ fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.25rem' }}>
                  Technique de respiration
                </h3>
                <p style={{ opacity: 0.9, fontSize: '0.9rem' }}>Respiration abdominale (cohérence de base)</p>
              </div>
              
              <div style={{ padding: '1.5rem' }}>
                {/* Objectif + Durée */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div style={{ background: '#EFF6FF', borderRadius: '0.75rem', padding: '1rem', borderLeft: '4px solid #5B8FB9' }}>
                    <h4 style={{ fontSize: '0.85rem', fontWeight: '700', color: '#5B8FB9', marginBottom: '0.35rem' }}>Objectif</h4>
                    <p style={{ fontSize: '0.9rem', color: '#555', margin: 0 }}>Activer le système nerveux parasympathique (calme).</p>
                  </div>
                  <div style={{ background: '#EFF6FF', borderRadius: '0.75rem', padding: '1rem', borderLeft: '4px solid #5B8FB9' }}>
                    <h4 style={{ fontSize: '0.85rem', fontWeight: '700', color: '#5B8FB9', marginBottom: '0.35rem' }}>Durée</h4>
                    <p style={{ fontSize: '0.9rem', color: '#555', margin: 0 }}>2 à 5 minutes</p>
                  </div>
                </div>

                {/* Comment faire */}
                <div style={{ background: 'white', border: '1px solid #e0e7ef', borderRadius: '0.75rem', padding: '1.25rem', marginBottom: '1.5rem' }}>
                  <h4 style={{ fontSize: '1rem', fontWeight: '700', color: '#333', marginBottom: '1rem' }}>Comment faire</h4>
                  <ol style={{ paddingLeft: '1.25rem', margin: 0 }}>
                    <li style={{ marginBottom: '0.6rem', fontSize: '0.9rem', color: '#444', lineHeight: '1.5' }}>
                      S'asseoir confortablement, dos droit, épaules relâchées.
                    </li>
                    <li style={{ marginBottom: '0.6rem', fontSize: '0.9rem', color: '#444', lineHeight: '1.5' }}>
                      Poser une main sur le ventre.
                    </li>
                    <li style={{ marginBottom: '0.6rem', fontSize: '0.9rem', color: '#444', lineHeight: '1.5' }}>
                      <strong style={{ color: '#5B8FB9' }}>Inspirer</strong> lentement par le nez en gonflant le ventre <strong>(4 secondes)</strong>.
                    </li>
                    <li style={{ marginBottom: '0.6rem', fontSize: '0.9rem', color: '#444', lineHeight: '1.5' }}>
                      <strong style={{ color: '#5B8FB9' }}>Expirer</strong> doucement par la bouche en rentrant le ventre <strong>(6 secondes)</strong>.
                    </li>
                    <li style={{ fontSize: '0.9rem', color: '#444', lineHeight: '1.5' }}>
                      Répéter <strong>10 cycles</strong>.
                    </li>
                  </ol>
                </div>

                {/* Images */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
                  <div style={{ borderRadius: '0.75rem', overflow: 'hidden', border: '1px solid #e0e7ef' }}>
                    <img 
                      src="https://customer-assets.emergentagent.com/job_7ea634f4-6c60-43bd-ad87-41da18485b19/artifacts/nraz9m71_image.png" 
                      alt="Respiration abdominale - Breathe in / Breathe out" 
                      style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                  </div>
                  <div style={{ borderRadius: '0.75rem', overflow: 'hidden', border: '1px solid #e0e7ef' }}>
                    <img 
                      src="https://customer-assets.emergentagent.com/job_7ea634f4-6c60-43bd-ad87-41da18485b19/artifacts/o27v9ale_image.png" 
                      alt="Respiration abdominale - Position de méditation" 
                      style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                  </div>
                </div>

                {/* Pourquoi ça fonctionne */}
                <div style={{ background: '#FFF7ED', border: '1px solid #FDBA74', borderRadius: '0.75rem', padding: '1rem', borderLeft: '4px solid #F97316' }}>
                  <h4 style={{ fontSize: '0.85rem', fontWeight: '700', color: '#F97316', marginBottom: '0.35rem' }}>Pourquoi ça fonctionne ?</h4>
                  <p style={{ fontSize: '0.9rem', color: '#555', margin: 0 }}>L'expiration plus longue que l'inspiration envoie un signal de sécurité au cerveau, ce qui ralentit le rythme cardiaque.</p>
                </div>

                {/* Bouton exercice guidé */}
                {breathingActive ? (
                  <div style={{ textAlign: 'center', padding: '2rem 1rem', background: breathingPhase === 'inspire' ? 'linear-gradient(135deg, #DBEAFE, #EFF6FF)' : breathingPhase === 'expire' ? 'linear-gradient(135deg, #FEF3C7, #FFF7ED)' : '#f8fafc', borderRadius: '1rem', border: `2px solid ${breathingPhase === 'inspire' ? '#93C5FD' : breathingPhase === 'expire' ? '#FCD34D' : '#e2e8f0'}`, transition: 'all 0.5s ease', marginTop: '1.25rem' }}>
                    <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#6B7280', marginBottom: '0.5rem' }}>
                      Cycle {breathingCycle}/10
                    </div>
                    <div style={{
                      width: breathingPhase === 'inspire' ? '160px' : breathingPhase === 'expire' ? '80px' : '120px',
                      height: breathingPhase === 'inspire' ? '160px' : breathingPhase === 'expire' ? '80px' : '120px',
                      borderRadius: '50%',
                      background: breathingPhase === 'inspire' ? 'linear-gradient(135deg, #3B82F6, #60A5FA)' : breathingPhase === 'expire' ? 'linear-gradient(135deg, #F59E0B, #FBBF24)' : '#94A3B8',
                      margin: '1rem auto',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'all 1s ease',
                      boxShadow: breathingPhase === 'inspire' ? '0 0 40px rgba(59,130,246,0.3)' : breathingPhase === 'expire' ? '0 0 40px rgba(245,158,11,0.3)' : 'none'
                    }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: '2rem' }}>
                        {breathingCount || '...'}
                      </span>
                    </div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 700, color: breathingPhase === 'inspire' ? '#2563EB' : breathingPhase === 'expire' ? '#D97706' : '#374151', marginBottom: '0.5rem' }}>
                      {breathingPhase === 'inspire' ? 'INSPIREZ' : breathingPhase === 'expire' ? 'EXPIREZ' : 'Préparez-vous...'}
                    </div>
                    <button
                      onClick={() => {
                        breathingRef.current = false;
                        setBreathingActive(false);
                        setBreathingPhase('');
                        setBreathingCount(0);
                        setBreathingCycle(0);
                        window.speechSynthesis.cancel();
                      }}
                      className="btn-secondary"
                      style={{ marginTop: '1rem', fontSize: '0.8rem' }}
                    >
                      Arrêter l'exercice
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={startBreathingExercise}
                    className="btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '1.25rem' }}
                  >
                    Démarrer l'exercice guidé (4s inspirer / 6s expirer)
                  </button>
                )}
              </div>
            </div>

            {/* Exercice 2: Respiration 4-4-6 */}
            <div style={{ marginBottom: '2rem' }}>
              <div className="card" style={{ padding: '1.5rem' }}>
                <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#DC2626', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  2. Respiration 4-4-6 (anti-montée de stress rapide)
                </h3>

                <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '0.75rem', padding: '0.75rem 1rem', marginBottom: '1rem', borderLeft: '4px solid #DC2626' }}>
                  <h4 style={{ fontSize: '0.82rem', fontWeight: 700, color: '#DC2626', marginBottom: '0.25rem' }}>Objectif</h4>
                  <p style={{ fontSize: '0.85rem', color: '#555', margin: 0 }}>Réguler rapidement une montée de tension (colère, agitation, surcharge).</p>
                </div>

                <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
                  <span style={{ padding: '0.3rem 0.75rem', borderRadius: '1rem', fontSize: '0.78rem', fontWeight: 600, background: '#FEE2E2', color: '#991B1B' }}>1 à 3 minutes</span>
                  <span style={{ padding: '0.3rem 0.75rem', borderRadius: '1rem', fontSize: '0.78rem', fontWeight: 600, background: '#FEE2E2', color: '#991B1B' }}>5 à 8 cycles</span>
                </div>

                <div style={{ marginBottom: '1rem' }}>
                  <h4 style={{ fontSize: '0.85rem', fontWeight: 700, color: '#374151', marginBottom: '0.5rem' }}>Les étapes :</h4>
                  <div style={{ display: 'grid', gap: '0.5rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.6rem 0.75rem', borderRadius: '10px', background: '#DBEAFE', border: '1px solid #93C5FD' }}>
                      <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#3B82F6', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem', flexShrink: 0 }}>4s</div>
                      <span style={{ fontSize: '0.88rem', fontWeight: 500 }}>Inspirer par le nez pendant 4 secondes</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.6rem 0.75rem', borderRadius: '10px', background: '#E0E7FF', border: '1px solid #A5B4FC' }}>
                      <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#6366F1', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem', flexShrink: 0 }}>4s</div>
                      <span style={{ fontSize: '0.88rem', fontWeight: 500 }}>Bloquer l'air 4 secondes</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.6rem 0.75rem', borderRadius: '10px', background: '#FEF3C7', border: '1px solid #FCD34D' }}>
                      <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#F59E0B', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.8rem', flexShrink: 0 }}>6s</div>
                      <span style={{ fontSize: '0.88rem', fontWeight: 500 }}>Expirer lentement par la bouche 6 secondes</span>
                    </div>
                  </div>
                  <p style={{ fontSize: '0.82rem', color: '#6B7280', marginTop: '0.5rem', fontStyle: 'italic' }}>Recommencer 5 à 8 fois</p>
                </div>

                <div style={{ background: '#ECFDF5', border: '1px solid #A7F3D0', borderRadius: '0.75rem', padding: '0.75rem 1rem', borderLeft: '4px solid #10B981' }}>
                  <h4 style={{ fontSize: '0.82rem', fontWeight: 700, color: '#059669', marginBottom: '0.25rem' }}>Astuce</h4>
                  <p style={{ fontSize: '0.85rem', color: '#555', margin: 0 }}>Compter mentalement ou utiliser ses doigts pour rythmer.</p>
                </div>

                {/* Exercice guidé 4-4-6 */}
                {breathingActive446 ? (
                  <div style={{ textAlign: 'center', padding: '2rem 1rem', background: breathingPhase446 === 'inspire' ? 'linear-gradient(135deg, #DBEAFE, #EFF6FF)' : breathingPhase446 === 'bloque' ? 'linear-gradient(135deg, #E0E7FF, #EEF2FF)' : breathingPhase446 === 'expire' ? 'linear-gradient(135deg, #FEF3C7, #FFF7ED)' : '#f8fafc', borderRadius: '1rem', border: `2px solid ${breathingPhase446 === 'inspire' ? '#93C5FD' : breathingPhase446 === 'bloque' ? '#A5B4FC' : breathingPhase446 === 'expire' ? '#FCD34D' : '#e2e8f0'}`, transition: 'all 0.5s ease', marginTop: '1.25rem' }}>
                    <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#6B7280', marginBottom: '0.5rem' }}>
                      Cycle {breathingCycle446}/8
                    </div>
                    <div style={{
                      width: breathingPhase446 === 'inspire' ? '160px' : breathingPhase446 === 'bloque' ? '160px' : breathingPhase446 === 'expire' ? '80px' : '120px',
                      height: breathingPhase446 === 'inspire' ? '160px' : breathingPhase446 === 'bloque' ? '160px' : breathingPhase446 === 'expire' ? '80px' : '120px',
                      borderRadius: '50%',
                      background: breathingPhase446 === 'inspire' ? 'linear-gradient(135deg, #3B82F6, #60A5FA)' : breathingPhase446 === 'bloque' ? 'linear-gradient(135deg, #6366F1, #818CF8)' : breathingPhase446 === 'expire' ? 'linear-gradient(135deg, #F59E0B, #FBBF24)' : '#94A3B8',
                      margin: '1rem auto',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      transition: 'all 1s ease',
                      boxShadow: breathingPhase446 === 'bloque' ? '0 0 40px rgba(99,102,241,0.3)' : breathingPhase446 === 'inspire' ? '0 0 40px rgba(59,130,246,0.3)' : breathingPhase446 === 'expire' ? '0 0 40px rgba(245,158,11,0.3)' : 'none'
                    }}>
                      <span style={{ color: 'white', fontWeight: 800, fontSize: '2rem' }}>
                        {breathingCount446 || '...'}
                      </span>
                    </div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 700, color: breathingPhase446 === 'inspire' ? '#2563EB' : breathingPhase446 === 'bloque' ? '#6366F1' : breathingPhase446 === 'expire' ? '#D97706' : '#374151', marginBottom: '0.5rem' }}>
                      {breathingPhase446 === 'inspire' ? 'INSPIREZ' : breathingPhase446 === 'bloque' ? 'BLOQUEZ' : breathingPhase446 === 'expire' ? 'EXPIREZ' : 'Préparez-vous...'}
                    </div>
                    <button
                      onClick={() => {
                        breathing446Ref.current = false;
                        setBreathingActive446(false);
                        setBreathingPhase446('');
                        setBreathingCount446(0);
                        setBreathingCycle446(0);
                        window.speechSynthesis.cancel();
                      }}
                      className="btn-secondary"
                      style={{ marginTop: '1rem', fontSize: '0.8rem' }}
                    >
                      Arrêter l'exercice
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={startBreathingExercise446}
                    className="btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '1.25rem' }}
                  >
                    Démarrer l'exercice guidé (4s inspirer / 4s bloquer / 6s expirer)
                  </button>
                )}
              </div>
            </div>

            {/* Respiration carrée 4-4-4-4 */}
            <div data-testid="breathing-square-section" style={{ marginBottom: '2rem', border: '2px solid #10B981', borderRadius: '1rem', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #D1FAE5, #A7F3D0)', padding: '1.25rem 1.5rem' }}>
                <h3 className="heading-2" style={{ color: '#065F46', marginBottom: '0.25rem' }}>
                  Respiration carrée (4-4-4-4)
                </h3>
                <p className="body-small" style={{ color: '#047857' }}>
                  Inspirez 4s → Retenez 4s → Expirez 4s → Retenez 4s — 8 cycles
                </p>
              </div>
              <div style={{ padding: '1.5rem' }}>
                <p className="body-small" style={{ marginBottom: '1rem', lineHeight: 1.6 }}>
                  La respiration carrée est utilisée par les forces spéciales et les athlètes de haut niveau pour retrouver calme et concentration en toutes circonstances. Quatre phases égales de 4 secondes forment un "carré" parfait qui stabilise le système nerveux.
                </p>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                  <span style={{ background: '#D1FAE5', color: '#065F46', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>Concentration</span>
                  <span style={{ background: '#DBEAFE', color: '#1E40AF', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>Anti-stress</span>
                  <span style={{ background: '#FEF3C7', color: '#92400E', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>Recentrage</span>
                </div>

                {breathingActiveSquare ? (
                  <div style={{ textAlign: 'center', padding: '2rem 1rem', background: breathingPhaseSquare === 'inspire' ? 'linear-gradient(135deg, #DBEAFE, #EFF6FF)' : (breathingPhaseSquare === 'bloque1' || breathingPhaseSquare === 'bloque2') ? 'linear-gradient(135deg, #D1FAE5, #ECFDF5)' : breathingPhaseSquare === 'expire' ? 'linear-gradient(135deg, #FEF3C7, #FFF7ED)' : '#f8fafc', borderRadius: '1rem', border: `2px solid ${breathingPhaseSquare === 'inspire' ? '#93C5FD' : (breathingPhaseSquare === 'bloque1' || breathingPhaseSquare === 'bloque2') ? '#6EE7B7' : breathingPhaseSquare === 'expire' ? '#FCD34D' : '#e2e8f0'}`, transition: 'all 0.5s ease', marginTop: '1.25rem' }}>
                    <p className="caption" style={{ marginBottom: '1rem' }}>
                      Cycle {breathingCycleSquare}/8
                    </p>
                    <div style={{
                      width: (breathingPhaseSquare === 'inspire' || breathingPhaseSquare === 'bloque1') ? '160px' : breathingPhaseSquare === 'expire' ? '80px' : breathingPhaseSquare === 'bloque2' ? '80px' : '120px',
                      height: (breathingPhaseSquare === 'inspire' || breathingPhaseSquare === 'bloque1') ? '160px' : breathingPhaseSquare === 'expire' ? '80px' : breathingPhaseSquare === 'bloque2' ? '80px' : '120px',
                      borderRadius: '0.75rem',
                      background: breathingPhaseSquare === 'inspire' ? 'linear-gradient(135deg, #3B82F6, #60A5FA)' : (breathingPhaseSquare === 'bloque1' || breathingPhaseSquare === 'bloque2') ? 'linear-gradient(135deg, #10B981, #34D399)' : breathingPhaseSquare === 'expire' ? 'linear-gradient(135deg, #F59E0B, #FBBF24)' : '#94A3B8',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 1.5rem auto', transition: 'all 0.8s ease',
                      boxShadow: breathingPhaseSquare === 'inspire' ? '0 0 40px rgba(59,130,246,0.3)' : (breathingPhaseSquare === 'bloque1' || breathingPhaseSquare === 'bloque2') ? '0 0 40px rgba(16,185,129,0.3)' : breathingPhaseSquare === 'expire' ? '0 0 40px rgba(245,158,11,0.3)' : 'none'
                    }}>
                      <span style={{ color: 'white', fontSize: '2.5rem', fontWeight: 700 }}>
                        {breathingCountSquare || '...'}
                      </span>
                    </div>
                    <div style={{ fontSize: '1.3rem', fontWeight: 700, color: breathingPhaseSquare === 'inspire' ? '#2563EB' : (breathingPhaseSquare === 'bloque1' || breathingPhaseSquare === 'bloque2') ? '#059669' : breathingPhaseSquare === 'expire' ? '#D97706' : '#374151', marginBottom: '0.5rem' }}>
                      {breathingPhaseSquare === 'inspire' ? 'INSPIREZ' : breathingPhaseSquare === 'bloque1' ? 'RETENEZ' : breathingPhaseSquare === 'expire' ? 'EXPIREZ' : breathingPhaseSquare === 'bloque2' ? 'RETENEZ' : 'Préparez-vous...'}
                    </div>
                    <button
                      onClick={() => {
                        breathingSquareRef.current = false;
                        window.speechSynthesis.cancel();
                        setBreathingActiveSquare(false);
                        setBreathingPhaseSquare('');
                        setBreathingCountSquare(0);
                        setBreathingCycleSquare(0);
                      }}
                      data-testid="stop-breathing-square-btn"
                      style={{ marginTop: '1rem', background: '#EF4444', color: 'white', border: 'none', borderRadius: '0.5rem', padding: '0.5rem 1.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}
                    >
                      Arrêter l'exercice
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={startBreathingExerciseSquare}
                    data-testid="start-breathing-square-btn"
                    className="btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '1.25rem' }}
                  >
                    Démarrer l'exercice guidé (4s inspirer / 4s retenir / 4s expirer / 4s retenir)
                  </button>
                )}
              </div>
            </div>

            {/* Respiration soupir physiologique */}
            <div data-testid="breathing-soupir-section" style={{ marginBottom: '2rem', border: '2px solid #8B5CF6', borderRadius: '1rem', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #EDE9FE, #DDD6FE)', padding: '1.25rem 1.5rem' }}>
                <h3 className="heading-2" style={{ color: '#5B21B6', marginBottom: '0.25rem' }}>
                  Respiration « soupir physiologique »
                </h3>
                <p className="body-small" style={{ color: '#6D28D9' }}>
                  Faire redescendre la pression en moins d'une minute
                </p>
              </div>
              <div style={{ padding: '1.5rem' }}>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                  <span style={{ background: '#EDE9FE', color: '#5B21B6', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>30s à 1 min</span>
                  <span style={{ background: '#FEF3C7', color: '#92400E', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>3 à 5 répétitions</span>
                </div>

                <div style={{ marginBottom: '1.25rem' }}>
                  <p className="body-small" style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#5B21B6' }}>Comment faire :</p>
                  <ol style={{ paddingLeft: '1.25rem', margin: 0 }}>
                    <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Inspirer profondément par le nez.</li>
                    <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Reprendre une petite inspiration supplémentaire (sans expirer).</li>
                    <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Expirer lentement et longuement par la bouche.</li>
                    <li className="body-small" style={{ lineHeight: 1.6 }}>Répéter 3 à 5 fois.</li>
                  </ol>
                </div>

                <div style={{ background: '#F5F3FF', borderLeft: '4px solid #8B5CF6', padding: '0.75rem 1rem', borderRadius: '0 0.5rem 0.5rem 0', marginBottom: '1.25rem' }}>
                  <p className="body-small" style={{ color: '#5B21B6', fontWeight: 600, marginBottom: '0.25rem' }}>Effet</p>
                  <p className="body-small" style={{ color: '#6D28D9' }}>Relâchement très rapide de la tension thoracique.</p>
                </div>

                {soupirVideoPlaying ? (
                  <div style={{ marginTop: '1rem' }}>
                    <video
                      ref={soupirVideoRef}
                      src="/audio/soupir_physiologique.mp4"
                      controls
                      autoPlay
                      onEnded={() => setSoupirVideoPlaying(false)}
                      style={{ width: '100%', borderRadius: '0.75rem', maxHeight: '450px', background: '#000' }}
                      data-testid="soupir-video-player"
                    />
                    <button
                      onClick={() => {
                        if (soupirVideoRef.current) {
                          soupirVideoRef.current.pause();
                          soupirVideoRef.current.currentTime = 0;
                        }
                        setSoupirVideoPlaying(false);
                      }}
                      data-testid="stop-soupir-btn"
                      style={{ marginTop: '1rem', width: '100%', background: '#EF4444', color: 'white', border: 'none', borderRadius: '0.5rem', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}
                    >
                      Arrêter l'exercice
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => setSoupirVideoPlaying(true)}
                    data-testid="start-soupir-btn"
                    className="btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }}
                  >
                    Démarrer l'exercice guidé (vidéo)
                  </button>
                )}
              </div>
            </div>

            {/* Respiration alternée */}
            <div data-testid="breathing-alternee-section" style={{ marginBottom: '2rem', border: '2px solid #F59E0B', borderRadius: '1rem', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #FEF3C7, #FDE68A)', padding: '1.25rem 1.5rem' }}>
                <h3 className="heading-2" style={{ color: '#92400E', marginBottom: '0.25rem' }}>
                  Respiration alternée
                </h3>
                <p className="body-small" style={{ color: '#B45309' }}>
                  Calmer le mental envahissant — 3 minutes
                </p>
              </div>
              <div style={{ padding: '1.5rem' }}>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                  <span style={{ background: '#FEF3C7', color: '#92400E', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>3 minutes</span>
                  <span style={{ background: '#EDE9FE', color: '#5B21B6', padding: '0.25rem 0.75rem', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600 }}>6 cycles</span>
                </div>

                <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
                  <div style={{ flex: '1 1 300px' }}>
                    <img src="/audio/respiration_alternee.png" alt="Respiration alternée - positions des doigts" style={{ width: '100%', borderRadius: '0.75rem', border: '1px solid #F3E8CC' }} />
                  </div>
                  <div style={{ flex: '1 1 300px' }}>
                    <p className="body-small" style={{ fontWeight: 600, marginBottom: '0.5rem', color: '#92400E' }}>Comment faire :</p>
                    <ol style={{ paddingLeft: '1.25rem', margin: 0 }}>
                      <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Boucher la narine droite → inspirer par la gauche.</li>
                      <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Boucher la gauche → expirer par la droite.</li>
                      <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Inspirer par la droite.</li>
                      <li className="body-small" style={{ marginBottom: '0.35rem', lineHeight: 1.6 }}>Boucher droite → expirer par la gauche.</li>
                      <li className="body-small" style={{ lineHeight: 1.6 }}>Continuer le cycle.</li>
                    </ol>
                  </div>
                </div>

                <div style={{ background: '#FFFBEB', borderLeft: '4px solid #F59E0B', padding: '0.75rem 1rem', borderRadius: '0 0.5rem 0.5rem 0', marginBottom: '1.25rem' }}>
                  <p className="body-small" style={{ color: '#92400E', fontWeight: 600, marginBottom: '0.25rem' }}>Idéal</p>
                  <p className="body-small" style={{ color: '#B45309' }}>Quand on rumine ou avant de dormir.</p>
                </div>

                {breathingActiveAlternee ? (
                  <div style={{ textAlign: 'center', padding: '2rem 1rem', background: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? 'linear-gradient(135deg, #DBEAFE, #EFF6FF)' : 'linear-gradient(135deg, #FEF3C7, #FFF7ED)', borderRadius: '1rem', border: `2px solid ${(breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? '#93C5FD' : '#FCD34D'}`, transition: 'all 0.5s ease', marginTop: '0.5rem' }}>
                    <p className="caption" style={{ marginBottom: '1rem' }}>
                      Cycle {breathingCycleAlternee}/6
                    </p>
                    <div style={{
                      width: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? '160px' : '100px',
                      height: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? '160px' : '100px',
                      borderRadius: '50%',
                      background: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? 'linear-gradient(135deg, #3B82F6, #60A5FA)' : 'linear-gradient(135deg, #F59E0B, #FBBF24)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 1.5rem auto', transition: 'all 0.8s ease',
                      boxShadow: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? '0 0 40px rgba(59,130,246,0.3)' : '0 0 40px rgba(245,158,11,0.3)'
                    }}>
                      <span style={{ color: 'white', fontSize: '2.5rem', fontWeight: 700 }}>
                        {breathingCountAlternee || '...'}
                      </span>
                    </div>
                    <div style={{ fontSize: '1.1rem', fontWeight: 700, color: (breathingPhaseAlternee === 'inspire-gauche' || breathingPhaseAlternee === 'inspire-droite') ? '#2563EB' : '#D97706', marginBottom: '0.25rem' }}>
                      {breathingPhaseAlternee === 'inspire-gauche' ? 'INSPIREZ (narine gauche)' : breathingPhaseAlternee === 'expire-droite' ? 'EXPIREZ (narine droite)' : breathingPhaseAlternee === 'inspire-droite' ? 'INSPIREZ (narine droite)' : breathingPhaseAlternee === 'expire-gauche' ? 'EXPIREZ (narine gauche)' : 'Préparez-vous...'}
                    </div>
                    <button
                      onClick={() => {
                        breathingAlterneeRef.current = false;
                        window.speechSynthesis.cancel();
                        setBreathingActiveAlternee(false);
                        setBreathingPhaseAlternee('');
                        setBreathingCountAlternee(0);
                        setBreathingCycleAlternee(0);
                      }}
                      data-testid="stop-breathing-alternee-btn"
                      style={{ marginTop: '1rem', background: '#EF4444', color: 'white', border: 'none', borderRadius: '0.5rem', padding: '0.5rem 1.5rem', cursor: 'pointer', fontWeight: 600, fontSize: '0.9rem' }}
                    >
                      Arrêter l'exercice
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={startBreathingExerciseAlternee}
                    data-testid="start-breathing-alternee-btn"
                    className="btn-primary"
                    style={{ width: '100%', justifyContent: 'center', marginTop: '0.5rem' }}
                  >
                    Démarrer l'exercice guidé (3 min)
                  </button>
                )}
              </div>
            </div>

            {/* Stress Management Techniques */}
            <div style={{ marginBottom: '2rem' }}>
              <h3 className="heading-2" style={{ marginBottom: '1.5rem' }}>
                Techniques de gestion du stress
              </h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
                <div className="card accent-orange hover-lift">
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    🧘 Méditation quotidienne
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    Pratiquez 10 minutes de méditation chaque matin pour commencer la journée sereinement.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Trouvez un endroit calme</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Concentrez-vous sur votre respiration</li>
                    <li className="caption">• Accueillez vos pensées sans jugement</li>
                  </ul>
                </div>

                <div className="card accent-green hover-lift">
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    💪 Activité physique
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    30 minutes d'exercice par jour réduisent considérablement le stress et améliorent la concentration.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Marche rapide</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Yoga ou stretching</li>
                    <li className="caption">• Natation ou vélo</li>
                  </ul>
                </div>

                <div className="card accent-grey hover-lift">
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    📝 Journal de bord
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    Écrivez vos pensées et ressentis pour mieux comprendre et gérer vos émotions.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Notez vos progrès quotidiens</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Identifiez vos sources de stress</li>
                    <li className="caption">• Célébrez vos petites victoires</li>
                  </ul>
                </div>

                <div className="card hover-lift" style={{ background: '#E4EDF8' }}>
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    😴 Sommeil de qualité
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    Un bon sommeil est essentiel pour gérer le stress et maintenir votre concentration.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Couchez-vous à heure fixe</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Évitez les écrans 1h avant</li>
                    <li className="caption">• Créez un environnement calme</li>
                  </ul>
                </div>

                <div className="card hover-lift" style={{ background: '#F9E8FA' }}>
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    🎵 Relaxation sonore
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    Musique douce, sons de la nature ou ASMR peuvent vous aider à vous détendre.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Playlist relaxante</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Sons binauraux</li>
                    <li className="caption">• Bruits blancs</li>
                  </ul>
                </div>

                <div className="card hover-lift" style={{ background: '#FEEFDC' }}>
                  <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                    👥 Soutien social
                  </h4>
                  <p className="body-small" style={{ marginBottom: '1rem' }}>
                    Partagez vos inquiétudes avec vos proches ou d'autres candidats VAE.
                  </p>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Groupe de soutien VAE</li>
                    <li className="caption" style={{ marginBottom: '0.25rem' }}>• Famille et amis</li>
                    <li className="caption">• Votre accompagnateur</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Emergency Contacts */}
            <div className="card" style={{ padding: '1.5rem', background: 'var(--bg-section)' }}>
              <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
                Besoin d'aide immédiate ?
              </h3>
              <p className="body-medium" style={{ marginBottom: '1.5rem' }}>
                Si vous ressentez un stress intense ou de l'anxiété qui impacte votre quotidien, n'hésitez pas à :
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <a href="mailto:apdr.vae@gmail.com" className="btn-primary" style={{ textDecoration: 'none', width: '100%' }}>
                  Contacter votre accompagnateur
                </a>
                <Link to="/booking?direct=true&type=soutien&formula=gold" className="btn-secondary" style={{ width: '100%' }}>
                  Réserver une séance de soutien
                </Link>
              </div>
            </div>
          </>
          )}
    </div>
  );
};

export default StressManagementTab;
